import { gql } from "@apollo/client";

export const GET_ENVIO_JUSTIFICACIONES = gql`
  query GetEnvioJustificaciones($idOrdenPedido: Int!, $idEvaluacion: Int!) {
    envioJustificaciones(
      idOrdenPedido: $idOrdenPedido
      idEvaluacion: $idEvaluacion
    ) {
      idJustificacion
      idEstadoComercial
      estadoComercial
      idMotivoJustificacionComercial
      justificadoComercial
      usuarioComercial
      fechaComercial
      obsComercial
      idEstadoMedico
      estadoMedico
      idMotivoJustificacionMedico
      justificadoMedico
      usuarioMedico
      fechaMedico
      obsMedico
      idEstadoBUM
      estadoBUM
      idMotivoJustificacionBUM
      justificadoBUM
      usuarioBUM
      obsBUM
      fechaBUM
    }
  }
`;